module.exports = __webpack_public_path__ + "static/democratise@2x-fcb93c33bc9e2798b7af1400a7a95090.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/consultancies/democratise@2x.jpg
// module id = 863
// module chunks = 56719701542624 281026976107462